import { React, useContext, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import YearFoundedFilter from "../../Components/RefineSearchComponents/YearFoundedFilter";
import InvestorTypeFilter from "../../Components/RefineSearchComponents/InvestorTypeFilter";
import InvestorHeadquartersFilter from "../../Components/RefineSearchComponents/InvestorHeadquartersFilter";
import ExitStatusFilterSelect from "../../Components/RefineSearchComponents/ExitStatusFilterSelect";
import ReturnMultipleFilter from "../RefineSearchComponents/ReturnMultipleFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import ExitDealTypeFilter from "../RefineSearchComponents/ExitDealTypeFilter";
import Constants from "../../Constants";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import { useLocation,useNavigate } from "react-router";
import { SelectTypeFilter } from '../RefineSearchComponents/TypeFilter'
import { useEffect } from "react";
import axios from "axios";
import { filterSectorByIndutry, tagList, filterLocationUrl, refineSearchSubFirmTypeUrl } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import DefinitionModal from "../TagDefinitionModal";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import CountryFilter from "../RefineSearchComponents/CountryFilter";
import RegionFilter from "../RefineSearchComponents/RegionFilter";
import StateFilter from "../RefineSearchComponents/StateFilter";
import CityFilter from "../RefineSearchComponents/CityFilter";
import FirmTypeSubMenu from "../RefineSearchComponents/FirmTypeSubMenu";
/**
 * The component renders a form for refining search filters.
 * @returns a JSX element.
 */
export default function ExitRefineSearch({ typeId, customPathname, generalPathname }) {
  const {
    
    setSectors,Sectors,dbDropdown , setDbDropdown ,setSubFirmType,
    setrefineSearchFilters,SwitchState,setSwitchState,checkToggleBtn,setToggleDealsBtn,
    InvestorOptions , setInvestorOptions ,dropdown,AllCities,
    lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,
    onErrorHandler ,setMonthPickerValue ,refineSearchFilters, getSectorByIndustry, accessControl,HeadquarterCityOptions,setHeadquarterCityOptions,selectedInvestorHeadquartersCity,setSelectedInvestorHeadquartersCity} = useContext(PeFilterContext);
  const { setCurrentPage } = useContext(TableDataContext);
  const [select, setSelected] = useState(32);
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const { getToken } = useContext(UserContext);
  // const isMatch = useMatch({ path: `${routePathSegments.pe}/${routePathSegments.companies}/${routePathSegments.exists}/*` })
  const location = useLocation();
  // const isPematch = useMatch({ path: `${routePathSegments.pe}/*` })

  const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
  const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false


  //local updated options
  const [IndustriesOptions, setIndustriesOptions] = useState([])
  const [SectorOptions, setSectorOptions] = useState([])
  const [EndYearOptions, setEndYearOptions] = useState([]);
  const [StartYearOptions, setStartYearOptions] = useState([])
  const [InvestorTypeOptions, setInvestorTypeOptions] = useState([])
  const [HeadquartersOptions, setHeadquartersOptions] = useState([])
  const [FirmTypeOptions, setFirmTypeOptions] = useState([])
  const [FirmSubTypeOptions, setFirmSubTypeOptions] = useState([])
  const [CountryOptions, setCountryOptions] = useState([])
  const [RegionOptions, setRegionOptions] = useState([])
  const [StateOptions, setStateOptions] = useState([])
  const [CityOptions, setCityOptions] = useState([])
  const [ExitDealTypeOptions, setExitDealTypeOptions] = useState([])
  const [TagSwitchState, setTagSwitchState] = useState(true)
  const [TagsOptions, setTagsOptions] = useState([])
  const [TypeOptions, setTypeOptions] = useState([])
  const [ExitStatusOptions, setExitStatusOptions] = useState([])
  const [ReturnMultiple, setReturnMultiple] = useState({ from: "", to: "" })
  
  // Centralized popup state management - only one filter popup can be open at a time
  const [openFilterPopup, setOpenFilterPopup] = useState(null);

  // useEffect(() => {
  //   setFirmType(firmTypeResponseData?.investments ?? [])
  // }, [firmTypeResponseData?.investments, setFirmType])

  // useEffect(() => {
  //   setExitStatus(exitStatusResponseData?.exits ?? [])
  // }, [exitStatusResponseData?.exits, setExitStatus])


  const applyFilter = () => {
    const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
    const selectedSectors = SectorOptions.filter(option => option.isChecked);
    const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
    const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
    const selectedInvestorType = InvestorTypeOptions?.filter(option => option.isChecked);
    const selectedHead = HeadquartersOptions?.filter(option => option.isChecked);
    const selectedHeadCity = HeadquarterCityOptions?.filter(option => option.isChecked);
    const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
    const selectedFirmSubTypes = FirmSubTypeOptions?.filter(option => option.isChecked);
    const selectedExit = ExitDealTypeOptions?.filter(option => option.isChecked);
    const selectedCountries = CountryOptions?.filter(option => option.isChecked);
    const selectedRegion = RegionOptions?.filter(option => option.isChecked);
    const selectedState = StateOptions?.filter(option => option.isChecked);
    const selectedCity = CityOptions?.filter(option => option.isChecked);
    const selectedType = TypeOptions?.filter(option => option.isChecked);
    const selectedExitStatus = ExitStatusOptions?.filter(option => option.isChecked);
    const selectedOperators = SwitchState;
    const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
    const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
    const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
    const selectedInvestor = InvestorOptions?.filter(option => option.isChecked); 
    const firmTypeNames = selectedFirm?.filter(firm => firm.isChecked).map(firm => firm.name) ?? [];
        let filteredFirmSubTypes = null;

        const excludedNames = ['Healthcare(PE)', 'Cleantech(PE)', 'Healthcare(VC)', 'Cleantech(VC)'];

        if (firmTypeNames.includes('PE') || firmTypeNames.includes('VC')) {
            filteredFirmSubTypes = selectedFirmSubTypes?.filter(sub => {
                const isPE = sub.name?.includes('(PE)') || sub.originalName?.includes('(PE)');
                const isVC = sub.name?.includes('(VC)') || sub.originalName?.includes('(VC)');

                if (firmTypeNames.includes('PE') && firmTypeNames.includes('VC')) {
                    return isPE || isVC;
                } else if (firmTypeNames.includes('PE')) {
                    return isPE;
                } else if (firmTypeNames.includes('VC')) {
                    return isVC;
                }
                return false;
            })?.map(sub => {
                if (!excludedNames.includes(sub.name)) {
                    return {
                        ...sub,
                        name: sub.name.replace(/\((PE|VC)\)/, ''),
                    };
                }
                return sub;
            }) ?? null;

            if (filteredFirmSubTypes.length === 0) {
                filteredFirmSubTypes = null;
            }
        }

    setrefineSearchFilters(prev => ({
      ...prev,
      [generalPathname]:{
        ...prev[generalPathname],
        industry: selectedIndustries,
        sector: selectedSectors,
        countries: selectedCountries,
        region: selectedRegion,
        state: selectedState,
        city: selectedCity,
        investorType: selectedInvestorType,
        investorHeadquarters: selectedHead,
        investor_headquaters_city: selectedHeadCity,
        yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
        firmType: selectedFirm,
        firm_Sub_type: filteredFirmSubTypes, 
        exitStatus: selectedExitStatus,
        operator: TagSwitchState ? 1 : 0,
        tags: TagsOptions,
        deals_operator : selectedOperators,
        ladvisors: selectedlAdvisors,
        tadvisors: selectedtAdvisors,
        investor_id : selectedInvestor ,
        target_company:selectedTargetCompany,
      },
      [customPathname]: {
        ...prev[customPathname],
        dealType: selectedExit,
        exitType: selectedType,
        returnMultiple: ReturnMultiple?.from != "" && ReturnMultiple?.to != "" ? [{ id: 0, name: ReturnMultiple?.from }, { id: 1, name: ReturnMultiple?.to }] : [],
      },
    }))
    checkToggleBtn();
    setSelectedInvestorHeadquartersCity(HeadquarterCityOptions?.filter(option => option.isChecked));
  }

  const resetFilter = () => {
    setrefineSearchFilters(prev => ({
      ...prev,
      [generalPathname]:{},
      [customPathname]: {}
    }))
    setHeadquarterCityOptions(HeadquarterCityOptions.map(option => {
        if (option.isChecked) {
            return { ...option, isChecked: false };
        }
        return option;
    }));
    setlAdvisorsOptions([]);
    settAdvisorsOptions([]);
    setTargetCompanyOptions([]);
    setInvestorOptions([]);
    setSectors([]);
    setToggleDealsBtn(true);
  }
  useEffect(()=>{
    setToggleDealsBtn(true);
  },[customPathname])
  

  // Submitting Refine Search Form 
  const refineSearchFilter = (event) => {
    setrefineSearchFilters(prev => ({
      ...prev,
      [generalPathname]: {
        ...prev[generalPathname],
      },
      [customPathname]: {globalSearch:[],
      }
  }))
  if(isFromGlobalSearch() || isFromSearchedList()){
      setMonthPickerValue(Constants.initialMonthRange)
  }
    event.preventDefault();
    setCurrentPage(1)
    // if (customPathname !== location.pathname) {
    //   navigate(routeNames.pe_companies_exists_pe_vc_investments);
    // }
    applyFilter();
    if (location.pathname != customPathname) {
      navigate(customPathname);
    }
    setSelected(false)

  }

 /**
  * The `onResetClick` function resets the current page, navigates to a custom pathname if it is
  * different from the current location, and resets the filter.
  * @param event - The event parameter is an object that represents the event that triggered the
  * function. In this case, it is the click event that occurred when the reset button was clicked.
  */
  const onResetClick = (event) => {
    event.preventDefault();
    setCurrentPage(1);
    // if (isMatch == null) {
    //   navigate(routeNames.pe_companies_exists_pe_vc_investments);
    // }
    if (location.pathname != customPathname) {
      navigate(customPathname)
    }
    resetFilter()
  }

  const accordionClick = (val) => {
    if (val === select) {
      setSelected(0);
    } else {
      setSelected(val);
    }
  };

  let exitDealTypeheading = "Deal Type";
  let exitTypeheading = "Type - Public Market (PE-VC)";
  let showTypeFilter = true;
  let showDealTypeFilter = true;

  if (typeId === Constants.primaryMasterSubIds.pe_vc_exits_id
    || typeId === Constants.primaryMasterSubIds.vc_exits_id) {
    exitDealTypeheading = "Deal Type - M&A (PE-VC)";
    showTypeFilter = true;
  } else {
    if (typeId === Constants.primaryMasterSubIds.pe_vc_pm_id || typeId === Constants.primaryMasterSubIds.vc_pm_id) {
      showTypeFilter = true;
      showDealTypeFilter = false;
      exitTypeheading = "Type";
    } else {
      showTypeFilter = false;
    }
  }

  useEffect(() => {
          const ids = IndustriesOptions?.length > 0 ? 
              IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];
  
          if (ids?.length > 0) {
              getSectorByIndustry(ids, "exits")
          } else {
              setSectors([])
          }
  
      }, [IndustriesOptions])
  
      useEffect(() => {
          if(accessControl?.peindustries?.id?.length > 0){
              const ids = accessControl ? accessControl?.peindustries?.id : []
              getSectorByIndustry(ids, "exits")
          }
      }, [])


  useEffect(() => {
    const countryIds = refineSearchFilters[generalPathname]?.countries?.map(value => value.id) ?? [];
    const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
    const stateIds = refineSearchFilters[generalPathname]?.state?.map(value => value.id) ?? [];
    const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
    axios.post(filterLocationUrl, {
        country: [],
        region: [],
        state: [],
        city: [],

    }, {
        headers: {
            "Authorization": getToken()
        }
    }).then(response => {
        if (response.status == 200) {
            setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
            setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
            setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
            setCityOptions(AllCities?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
        }
    }).catch(onErrorHandler)
}, [refineSearchFilters,AllCities])

// useEffect(() => {
//         const ids = FirmTypeOptions?.filter(industry => industry.isChecked)?.map(option => option.id);

//         if (ids?.length > 0) {
//             let firmType = "All";
//             if (ids.length === 1) {
//                 if (ids[0] === 1) firmType = "PE";
//                 else if (ids[0] === 2) firmType = "VC";
//             }

//             axios.post(refineSearchSubFirmTypeUrl, {
//                 firm_type: firmType,
//             }, {
//                 headers: {
//                     "Authorization": getToken()
//                 }
//             }).then(response => {
//                 if (response.status === 200) {
//                     setSubFirmType(response.data?.firmType ?? []);
//                 } else {
//                     setSubFirmType([]);
//                 }
//             }).catch(onErrorHandler);
//         } else {
//             setSubFirmType([]);
//         }
//     }, [FirmTypeOptions]);

  const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "type"    : type,
            "includes_secondary_tags": secondaryTagCheck

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }

    const onCountryChange = (options) => {
      const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
      axios.post(filterLocationUrl, {
          country: ids,
          region: [],
          state: [],
          city: [],

      }, {
          headers: {
              "Authorization": getToken()
          }
      }).then(response => {
          if (response.status == 200) {
              setRegionOptions(response.data?.region)
              setStateOptions(response.data.state)
              setCityOptions(response.data?.city)
          }
      }).catch(onErrorHandler)
  }

  const onRegionChange = (options) => {
      const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
      const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
      axios.post(filterLocationUrl, {
          country: selectedCountries,
          region: ids,
          state: [],
          city: [],

      }, {
          headers: {
              "Authorization": getToken()
          }
      }).then(response => {
          if (response.status == 200) {
              setStateOptions(response.data.state)
              setCityOptions(response.data?.city)
          }
      }).catch(onErrorHandler)
  }

  const onStateChange = (options) => {
      const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
      const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
      const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
      axios.post(filterLocationUrl, {
          country: selectedCountries,
          region: selectedRegion,
          state: ids,
          city: [],

      }, {
          headers: {
              "Authorization": getToken()
          }
      }).then(response => {
          if (response.status == 200) {
              setCityOptions(response.data?.city)
          }
      }).catch(onErrorHandler)
  }

    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };
    
    const  [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    console.log(defValues, 'showValues');

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }

const handleDbToggle = () => {
  setDbDropdown(!dbDropdown);
};

const getPeVcSelectedTypes = () => {
  return FirmTypeOptions?.filter(option => 
    (option.id === 1 || option.id === 2) && option.isChecked
  ) || [];
};

  // State for managing which filter section is active
  const [activeFilterSection, setActiveFilterSection] = useState("keyword");

  // Helper functions to count applied filters for each section
  const getDealFiltersCount = () => {
    const hasDealType = ExitDealTypeOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasType = TypeOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasReturnMultiple = (ReturnMultiple?.from !== "" && ReturnMultiple?.to !== "") ? 1 : 0;
    const hasExitStatus = ExitStatusOptions?.some(option => option.isChecked) ? 1 : 0;
    
    return hasDealType + hasType + hasReturnMultiple + hasExitStatus;
  };

  const getCompanyFiltersCount = () => {
    const hasIndustry = IndustriesOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasSector = SectorOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasYearFounded = (StartYearOptions?.some(option => option.isChecked) || EndYearOptions?.some(option => option.isChecked)) ? 1 : 0;
    const hasCountry = CountryOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasRegion = RegionOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasState = StateOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasCity = CityOptions?.some(option => option.isChecked) ? 1 : 0;
    
    return hasIndustry + hasSector + hasYearFounded + hasCountry + hasRegion + hasState + hasCity;
  };

  const getInvestorFiltersCount = () => {
    const hasInvestorType = InvestorTypeOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasHeadquarters = HeadquartersOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasHeadquarterCity = HeadquarterCityOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasFirmType = FirmTypeOptions?.some(option => option.isChecked) ? 1 : 0;
    
    return hasInvestorType + hasHeadquarters + hasHeadquarterCity + hasFirmType;
  };

  const getKeywordFiltersCount = () => {
    const hasTagFilters = TagsOptions?.length > 0 ? 1 : 0;
    const hasInvestor = InvestorOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasTargetCompany = TargetCompanyOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasLAdvisor = lAdvisorsOptions?.some(option => option.isChecked) ? 1 : 0;
    const hasTAdvisor = tAdvisorsOptions?.some(option => option.isChecked) ? 1 : 0;
    
    return hasTagFilters + hasInvestor + hasTargetCompany + hasLAdvisor + hasTAdvisor;
  };

  return (
    <div className="bg-white">
      <div className="h-full flex flex-col">
        <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full flex flex-col">
          <main className="flex-1 w-full py-4 overflow-hidden">
            <div className="h-full flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4">
              {/* Left Sidebar - Filter Categories */}
              <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-center md:items-stretch overflow-hidden flex-wrap md:flex-nowrap no-scrollbar">
                <div 
                  className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                    activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                >
                  <div className="flex items-center gap-1 md:gap-2">
                    <span className="text-xs md:text-base font-medium">Keyword Search</span>
                    {getKeywordFiltersCount() > 0 && (
                      <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                        {getKeywordFiltersCount()}
                      </span>
                    )}
                  </div>
                  {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                </div>
                
                <div 
                  className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                    activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                >
                  <div className="flex items-center gap-1 md:gap-2">
                    <span className="text-xs md:text-base font-medium">Deal</span>
                    {getDealFiltersCount() > 0 && (
                      <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                        {getDealFiltersCount()}
                      </span>
                    )}
                  </div>
                  {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                </div>
                
                <div 
                  className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                    activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                >
                  <div className="flex items-center gap-1 md:gap-2">
                    <span className="text-xs md:text-base font-medium">Company</span>
                    {getCompanyFiltersCount() > 0 && (
                      <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                        {getCompanyFiltersCount()}
                      </span>
                    )}
                  </div>
                  {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                </div>
                
                <div 
                  className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                    activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                >
                  <div className="flex items-center gap-1 md:gap-2">
                    <span className="text-xs md:text-base font-medium">Investor</span>
                    {getInvestorFiltersCount() > 0 && (
                      <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'investor' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                        {getInvestorFiltersCount()}
                      </span>
                    )}
                  </div>
                  {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                </div>
              </div>
              
              {/* Right Content Area - Filter Options */}
              <div className="col-span-full md:col-span-6 h-full overflow-y-auto overflow-x-hidden md:overflow-y-auto md:overflow-x-hidden md:no-scrollbar mt-4 md:mt-0 pb-4 md:pb-0 relative">
                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative flex flex-col overflow-y-auto md:overflow-y-visible md:no-scrollbar`}>
                  <div className="space-y-4">
                    <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-2">
                      <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                          <Tags
                              TagsOptions={TagsOptions}
                              customPathname={generalPathname}
                              setTagsOptions={setTagsOptions} 
                              getSearchTags={getSearchTags}
                              SwitchState={TagSwitchState}
                              setSwitchState={setTagSwitchState}
                          />
                          <Switch
                              SwitchState={TagSwitchState}
                              setSwitchState={setTagSwitchState}
                              customPathname={generalPathname} 
                          />
                      </div>
                      <div className="md:hidden flex items-center">
                          <Tooltip title='Tag List'>
                              <FaInfoCircle 
                                  size={16} 
                                  color="grey" 
                                  className="cursor-pointer px-[1px]"
                                  onClick={fetchData}
                              />
                          </Tooltip>
                      </div>
                  </div>
                  <div className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                      <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                      <span>include secondary tags</span>
                  </div>
                  <Tooltip title='Tag List'>
                      <FaInfoCircle 
                          size={16} 
                          color="grey" 
                          className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                          onClick={fetchData}
                      />
                  </Tooltip>
                  </div>
                  <div className="mt-4 space-y-4">
                    <Investor 
                      options={InvestorOptions}
                      setOptions={setInvestorOptions}
                      customPathname={generalPathname}
                      accordionClick={() => accordionClick(32)}
                      label="Investor"
                      open={select === 32}
                    />
                    <TargetCompany 
                      options={TargetCompanyOptions}
                      setOptions={setTargetCompanyOptions}
                      customPathname={generalPathname}
                      accordionClick={() => accordionClick(31)}
                      label="Company"
                      open={select === 31}
                    />
                    <LAdvisor 
                      options={lAdvisorsOptions}
                      setOptions={setlAdvisorsOptions}
                      customPathname={generalPathname}
                      label="Legal Advisors"
                      accordionClick={() => accordionClick(21)}
                      open={select === 21}
                    />
                    <TAdvisor 
                      options={tAdvisorsOptions}
                      setOptions={settAdvisorsOptions}
                      label="Transaction Advisors"
                      customPathname={generalPathname}
                      accordionClick={() => accordionClick(29)}
                      open={select === 29}
                    />
                  </div>
                </div>
                
                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                  {showDealTypeFilter && (
                    <ExitDealTypeFilter
                      ExitDealTypeOptions={ExitDealTypeOptions}
                      setExitDealTypeOptions={setExitDealTypeOptions}
                      customPathname={customPathname}
                      dataPath="others"
                      heading={exitDealTypeheading}
                      isPopupOpen={openFilterPopup === 'exitDealType'}
                      setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitDealType' : null)}
                    />
                  )}
                  {showTypeFilter ? (
                    <SelectTypeFilter
                      TypeOptions={TypeOptions}
                      setTypeOptions={setTypeOptions}
                      customPathname={customPathname}
                      heading={exitTypeheading}
                      isPopupOpen={openFilterPopup === 'exitType'}
                      setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitType' : null)}
                    />
                  ) : null}
                  <ReturnMultipleFilter
                    customPathname={customPathname}
                    ReturnMultiple={ReturnMultiple}
                    setReturnMultiple={setReturnMultiple}
                    isPopupOpen={openFilterPopup === 'returnMultiple'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'returnMultiple' : null)}
                  />
                  <ExitStatusFilterSelect
                    ExitStatusOptions={ExitStatusOptions}
                    setExitStatusOptions={setExitStatusOptions}
                    customPathname={generalPathname}
                    dataPath="exits"
                    isPopupOpen={openFilterPopup === 'exitStatus'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'exitStatus' : null)}
                  />
                </div>
                
                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-2 md:gap-x-6 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                  <IndustryFilter
                    IndustriesOptions={IndustriesOptions}
                    setIndustriesOptions={setIndustriesOptions}
                    customPathname={generalPathname}
                    accordionClick={() => accordionClick(1)}
                    open={select === 1}
                    isPopupOpen={openFilterPopup === 'industry'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                  />
                  <SectorFilter
                    SectorOptions={SectorOptions}
                    setSectorOptions={setSectorOptions}
                    accordionClick={() => accordionClick(2)}
                    customPathname={generalPathname}
                    open={select === 2}
                    isPopupOpen={openFilterPopup === 'sector'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                  />
                  <YearFoundedFilter
                    EndYearOptions={EndYearOptions}
                    customPathname={generalPathname}
                    setEndYearOptions={setEndYearOptions}
                    StartYearOptions={StartYearOptions}
                    setStartYearOptions={setStartYearOptions}
                    isPopupOpen={openFilterPopup === 'yearFounded'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'yearFounded' : null)}
                  />
                  <CountryFilter
                    CountryOptions={CountryOptions}
                    setCountryOptions={setCountryOptions}
                    customPathname={generalPathname}
                    accordionClick={() => accordionClick(10)}
                    onChange={onCountryChange}
                    open={select === 10}
                    isPopupOpen={openFilterPopup === 'country'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'country' : null)}
                  />
                  <RegionFilter
                    RegionOptions={RegionOptions}
                    setRegionOptions={setRegionOptions}
                    customPathname={generalPathname}
                    onChange={onRegionChange}
                    isPopupOpen={openFilterPopup === 'region'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)}
                  />
                  <StateFilter
                    StateOptions={StateOptions}
                    setStateOptions={setStateOptions}
                    customPathname={generalPathname}
                    onChange={onStateChange}
                    isPopupOpen={openFilterPopup === 'state'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'state' : null)}
                  />
                  <CityFilter
                    CityOptions={CityOptions}
                    setCityOptions={setCityOptions}
                    customPathname={generalPathname}
                    isPopupOpen={openFilterPopup === 'city'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                  />
                </div>
                
                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}>
                  <FirmTypeFilter
                    FirmTypeOptions={FirmTypeOptions}
                    setFirmTypeOptions={setFirmTypeOptions}
                    FirmSubTypeOptions={FirmSubTypeOptions}
                    setFirmSubTypeOptions={setFirmSubTypeOptions}
                    customPathname={generalPathname}
                    dataPath="investments"
                    isPopupOpen={openFilterPopup === 'firmType'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)}
                  />
                  <InvestorHeadquartersFilter
                    HeadquartersOptions={HeadquartersOptions}
                    setHeadquartersOptions={setHeadquartersOptions}
                    customPathname={generalPathname}
                    setHeadquarterCityOptions={setHeadquarterCityOptions}
                    HeadquarterCityOptions={HeadquarterCityOptions}
                    isPopupOpen={openFilterPopup === 'investorHeadquarters'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorHeadquarters' : null)}
                  />
                  <InvestorTypeFilter
                    InvestorTypeOptions={InvestorTypeOptions}
                    setInvestorTypeOptions={setInvestorTypeOptions}
                    customPathname={generalPathname}
                    isPopupOpen={openFilterPopup === 'investorType'}
                    setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'investorType' : null)}
                  />
                </div>
                
                {!activeFilterSection && (
                  <div className="flex items-center justify-center h-40 text-gray-500">
                    <p>Select a filter category from the left to view available filters</p>
                  </div>
                )}
              </div>
            </div>
          </main>
        </form>
      </div>
      {showDefinitionModal && 
        <DefinitionModal 
          values={defValues} 
          onClose={defCloseHandler} 
          TagsOptions={TagsOptions} 
          setTagsOptions={setTagsOptions}
          customPathname={generalPathname}
        />}
    </div>
  );
}

